import {getContrast, getRgbColorFromHex, RGB} from "@/utils/dominantColorOptimiser";
import {Campaign} from "@/models/campaign";
import {Image} from "@/models/image";

const DEFAULT_FOREGROUND_COLOR = "#46DEB5";
const DEFAULT_BACKGROUND_COLOR = "#E4F4EF";

function colorFor(campaign: Campaign): string {
    if (campaign.color) {
        return campaign.color;
    }

    if (campaign.profile.brandColor) {
        return campaign.profile.brandColor;
    }

    return DEFAULT_FOREGROUND_COLOR;
}

function backgroundColorFor(campaign: Campaign): string {
    if (campaign.backgroundColor) {
        return campaign.backgroundColor;
    }

    return DEFAULT_BACKGROUND_COLOR;
}

function primaryTextColorFor(campaign: Campaign): string {
    if (contrastFor(colorFor(campaign), DEFAULT_BACKGROUND_COLOR) > 4.0) {
        return "#FFFFFF";
    }

    return "#000000";
}

function textColorOnBackgroundFor(campaign: Campaign): string {
    if (contrastFor(backgroundColorFor(campaign), DEFAULT_BACKGROUND_COLOR) > 4.0) {
        return "#FFFFFF";
    }

    return "#000000";
}

function contrastFor(primaryColor: string, secondaryColor: string): number {
    const primary: RGB = getRgbColorFromHex(primaryColor);
    const secondary: RGB = getRgbColorFromHex(secondaryColor);
    return getContrast(primary, secondary);
}
//
// function backgroundImageURLFor(campaign: Campaign): string | undefined {
//     const image = backgroundImageFor(campaign);
//     if (image) {
//         return Helper.getImageUrl(image, 900, 1200);
//     }
//
//     return undefined;
// }

function backgroundImageFor(campaign: Campaign): Image | undefined {
    if (campaign.backgroundImage) {
        return campaign.backgroundImage;
    }

    return undefined;
}

export default {
    shouldShowBackgroundImageFor(campaign: Campaign): boolean {
        return backgroundImageFor(campaign) !== undefined;
    },

    setDocumentColorsFor(campaign: Campaign) {
        const root = document.documentElement;
        root.style.setProperty('--creation-primary-color', getRgbColorFromHex(colorFor(campaign)).join(' '));
        root.style.setProperty('--creation-bg-color', getRgbColorFromHex(backgroundColorFor(campaign)).join(' '));
        root.style.setProperty('--creation-primary-text-color', getRgbColorFromHex(primaryTextColorFor(campaign)).join(' '));
        root.style.setProperty('--creation-text-color', getRgbColorFromHex(textColorOnBackgroundFor(campaign)).join(' '));

         if (contrastFor(backgroundColorFor(campaign), DEFAULT_BACKGROUND_COLOR) > 4.0) {
            // Dark Mode
            root.style.setProperty('--creation-opacity-full', '1');
            root.style.setProperty('--creation-opacity-high', '0.7');
            root.style.setProperty('--creation-opacity-medium', '0.5');
            root.style.setProperty('--creation-opacity-low', '0.3');
            root.style.setProperty('--creation-opacity-separator', '0.2');
            root.style.setProperty('--creation-opacity-circle1', '0.12');
            root.style.setProperty('--creation-opacity-circle2', '0.1');
        } else {
            // Light Mode
            root.style.setProperty('--creation-opacity-full', '1');
            root.style.setProperty('--creation-opacity-high', '0.6');
            root.style.setProperty('--creation-opacity-medium', '0.4');
            root.style.setProperty('--creation-opacity-low', '0.2');
            root.style.setProperty('--creation-opacity-separator', '0.1');
            root.style.setProperty('--creation-opacity-circle1', '0.05');
            root.style.setProperty('--creation-opacity-circle2', '0.03');
        }
    },
}
